module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFAgMAAAABCpX7AAAACVBMVEUAAACztL6ztL5sv6oYAAAAA3RSTlMAf4C/aSLHAAAAHElEQVQIHWOYwJDAoMLYwMDJxsDAFMHAwLCAAQAdywKfXYE86QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/common/footer-select.png
// module id = sm8r
// module chunks = 15